// extracted by mini-css-extract-plugin
export var wordContainer = "_pm-0";